import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Vstopne strani",
  "description": "",
  "published": "2007-03-31T00:00:00.000Z",
  "redirect_from": ["/blog/vstopne-strani/swizec/248"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vsi smo v svojem spletnem Å¾ivljenju Å¾e kdaj naleteli na vstopno stran in le-te so tiho zlo, ki preÅ¾i v globinah. Velikokrat bo podjetje, ki dobiva novo spletno podobo, vztrajalo na vstopni strani in se sploh ne zavedalo kakšen vpliv bo imela na njihov obisk in pravzaprav kako slabo so sprejete v skupnosti.`}</p>
    <p>{`NajveÄji problem pri vstopnih straneh je, da ko sprehajalnik spletnega iskalnika naleti na tako stran v bistvu ne vidi prav veliko vsebine in redkokdaj kaj dovolj zanimivega, da bi temu prisodil visoko mesto v iskalnih rezultatih. Pred kratkim sem celo naletel na problem, ko je bilo potrebno nasilno ustvariti vsebino za na vstopno stran, ker je drugaÄe v iskalnih rezultatih sploh ni bilo, kaj šele, da bi imela pripisano kako vrednost.`}</p>
    <p>{`Še en velik problem je, da vstopna stran ponavadi pomeni neuporabno spletno mesto. Kadar je le-to osnovano na skupnosti ali pa je polno neke dokaj uporabne vsebine, ponavadi ni skrito za vstopno stranjo, ampak se takoj pokaÅ¾e v skladu z naÄelom, da internet hrepeni takojšnjih informacij. Nasprotno , kaÅ¾e, velja za neuporabne strani, kjer podjetje morebiti potrebuje vstopno stran, da sploh prikaÅ¾ejo svoj logotip in ustvarijo vsaj nekaj svoje podobe, ker drugaÄe morda uporabnik na neuporabni strani sploh ne bi preÅ¾ivel dovolj Äasa.`}</p>
    <p>{`Hkrati obstaja dobro znani zakon treh klikov, kjer naj bi bila vsa uporabniku pomembna vsebina dostopna preko najveÄ treh klikov in uganite kaj, vstopna stran doda enega teh. Osebno Äe me pozdravi vstopna stran in nisem Å¾e vnaprej prepriÄan o zanimivosti vsebine, preprosto odidem`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      